<template>
  <v-dialog
    v-model="dialog"
    :width="step === 1? '330px': '510px'">
    <div class="dialog-container">
      <h3>Void Quote</h3>
      <p v-if="step === 0">Once this quote is voided, the quote will not be purchaseable anymore. Continue?</p>
      <p v-else>This quote has been voided. </p>
      <div v-if="step === 1">
        <v-button
          type="primary"
          @click="handlerDone">Done</v-button>
      </div>
      <div
        v-else
        class="dialog-footer">
        <v-button @click="dialog = false">Cancel</v-button>
        <v-button
          type="primary"
          @click="handlerContinue">Continue</v-button>
      </div>
    </div>
  </v-dialog>
</template>
<script>
import { voidOrder } from '@/api/order'
export default {
  name: 'VoidQuoteDialog',
  props: {
    orderId: [String, Number],
  },
  data() {
    return {
      step: 0,
      dialog: false
    }
  },
  methods: {
    changeDialog() {
      if(this.step = 1) {
        this.step = 0
      }
      this.dialog = !this.dialog
    },
    handlerDone() {
      this.step = 0
      this.$emit('done')
      this.dialog = false
    },
    handlerContinue() {
      this.network().voidOrder()
    },
    network() {
      return {
        voidOrder: async () => {
          const { data } = await voidOrder({
            order_id: this.orderId
          })
          this.step = 1
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
      padding: 15px;
      p {
        padding-bottom: 10px;
      }
      .dialog-footer {
        margin: 15px -15px -15px;
        padding: 15px;
        text-align: right;
        background: #F9FAFB;
      }
    }
</style>